import { Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import Layout from './components/Layout';
import Home from './pages/Home';
import Blog from './pages/Blog';
import ArticlePage from './pages/ArticlePage';
import Tools from './pages/tools/Tools';
import JsonFormatter from './pages/tools/JsonFormatter';
import WordCounter from './pages/tools/WordCounter';
import CaseConverter from './pages/tools/CaseConverter';
import LoremGenerator from './pages/tools/LoremGenerator';
import Base64Tool from './pages/tools/Base64Tool';
import UuidGenerator from './pages/tools/UuidGenerator';
import ColorConverter from './pages/tools/ColorConverter';
import TimestampConverter from './pages/tools/TimestampConverter';
import HashGenerator from './pages/tools/HashGenerator';
import MarkdownPreview from './pages/tools/MarkdownPreview';
import PasswordGenerator from './pages/tools/PasswordGenerator';
import LoanCalculator from './pages/tools/LoanCalculator';
import RoiCalculator from './pages/tools/RoiCalculator';
import SalaryCalculator from './pages/tools/SalaryCalculator';
import SeoChecker from './pages/tools/SeoChecker';
import SipCalculator from './pages/tools/SipCalculator';
import CsvTools from './pages/tools/CsvTools';
import Learn from './pages/Learn';
import GuidePage from './pages/GuidePage';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Products from './pages/Products';
import MarketingAgent from './pages/MarketingAgent';
import NotFound from './pages/NotFound';
import features from './features';
import './App.css';

// Agent pages — only imported when feature is enabled to keep bundle clean
const AuthPage = features.agentEnabled ? require('./pages/agent/AuthPage').default : null;
const OnboardingPage = features.agentEnabled ? require('./pages/agent/OnboardingPage').default : null;
const Dashboard = features.agentEnabled ? require('./pages/agent/Dashboard').default : null;
const SignIn = features.agentEnabled ? require('./pages/SignIn').default : null;

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<ArticlePage />} />
          <Route path="tools" element={<Tools />} />
          <Route path="json-formatter" element={<JsonFormatter />} />
          <Route path="word-counter" element={<WordCounter />} />
          <Route path="case-converter" element={<CaseConverter />} />
          <Route path="lorem-generator" element={<LoremGenerator />} />
          <Route path="base64" element={<Base64Tool />} />
          <Route path="uuid-generator" element={<UuidGenerator />} />
          <Route path="color-converter" element={<ColorConverter />} />
          <Route path="timestamp" element={<TimestampConverter />} />
          <Route path="hash-generator" element={<HashGenerator />} />
          <Route path="markdown-preview" element={<MarkdownPreview />} />
          <Route path="password-generator" element={<PasswordGenerator />} />
          <Route path="loan-calculator" element={<LoanCalculator />} />
          <Route path="roi-calculator" element={<RoiCalculator />} />
          <Route path="salary-calculator" element={<SalaryCalculator />} />
          <Route path="seo-checker" element={<SeoChecker />} />
          <Route path="sip-calculator" element={<SipCalculator />} />
          <Route path="csv-tools" element={<CsvTools />} />
          <Route path="learn" element={<Learn />} />
          <Route path="learn/:slug" element={<GuidePage />} />
          <Route path="products" element={<Products />} />
          <Route path="products/marketing-agent" element={<MarketingAgent />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<Terms />} />
          {features.agentEnabled && <Route path="signin" element={<SignIn />} />}
          <Route path="*" element={<NotFound />} />
        </Route>
        {features.agentEnabled && <Route path="agent" element={<AuthPage />} />}
        {features.agentEnabled && <Route path="agent/onboarding" element={<OnboardingPage />} />}
        {features.agentEnabled && <Route path="agent/dashboard/:projectId" element={<Dashboard />} />}
      </Routes>
      <Analytics />
      <SpeedInsights />
    </>
  );
}

export default App;
